
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useStore } from '@/plugins/store/index';
import GenericTable from '@/components/tables/GenericTable.vue';
import { Thought, ThoughtStatistics } from '@/types';

export default defineComponent({
    components: { GenericTable },
    data() {
        function cellRendererSelector(params: any) {
            if (params.node.rowPinned) {
                return {
                    component: 'CustomPinnedRowCellRenderer',
                };
            }
            if (params.colDef.field === 'icon') {
                return {
                    component: 'IconCellRenderer',
                };
            }
            return {
                component: 'GenericCellRenderer',
            };
        }
        return {
            headers: [
                {
                    width: 8,
                    headerName: '',
                    field: 'icon',
                    sortable: true,
                    cellRendererSelector,
                },
                {
                    headerName: 'Tanke',
                    field: 'title',
                    sortable: true,
                    cellRendererSelector,
                },
                {
                    headerName: 'Antal',
                    field: 'amount',
                    sortable: true,
                    cellRendererSelector,
                },
            ],
        };
    },
    computed: {
        ...mapState(useStore, ['thoughtStatistics', 'thoughts']),
        pinnedBottomRowData(): any {
            return [
                {
                    icon: null,
                    title: 'Total',
                    amount: this.items.reduce((accum, current) => {
                        return accum + current.amount;
                    }, 0),
                },
            ];
        },
        items(): any[] {
            if (!this.thoughtStatistics || !this.thoughts) {
                return [];
            }
            return [
                ...this.thoughts.map((thought: Thought) => {
                    return {
                        icon: thought.iconUrl,
                        title: thought.title,
                        amount: this.thoughtStatistics.filter((statistic: ThoughtStatistics) => statistic.ref === thought.id || statistic.refs?.includes(thought.id)).length,
                    };
                }),
            ];
        },
    },
});
